import { Component, inject, input, output, Signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { getOrderStateTag } from 'app/order/fns';
import { PriceService } from 'app/order/price/price.service';
import { SplitCurrencyPipe } from '../../../shared/pipes/split-currency.pipe';

@Component({
    selector: 'app-product-advice-result-box',
    templateUrl: './product-advice-result-box.component.html',
    styleUrl: './product-advice-result-box.component.scss',
    imports: [RouterLink, SplitCurrencyPipe],
})
export class ProductAdviceResultBoxComponent {
    public shouldChangeTheftCoverage = input<boolean>(false);
    public shouldChangeDeductible = input<boolean>(false);
    public wrongInsurance = input<boolean>(false);
    public recommendedPrice = input<number | null>(null);

    public applyAdvice = output<boolean | null>();

    protected hasDeductible = getOrderStateTag('hasDeductible') as Signal<boolean>;
    protected hasTheftCoverage = getOrderStateTag('hasTheftCoverage') as Signal<boolean>;
    protected price = inject(PriceService).price;
}
